module.exports = __webpack_public_path__ + "img/cart.827baccd.svg";